<template>
  <el-dialog title="人员成本详情" :visible.sync="dialogVisible" width="860px" append-to-body>
    <div v-loading="loading">
      <div v-if="header" class="header-info">
        <span>岗位：{{ header.stationName }}</span>
        <span>人员：{{ header.userName || header.userId }}</span>
        <span>总成本：{{ formatAmount(header.totalCost) }}</span>
      </div>
      <el-table :data="items" border size="small" max-height="420" empty-text="暂无成本明细">
        <el-table-column label="成本类型" width="120">
          <template slot-scope="scope">{{ costTypeLabel(scope.row.costType) }}</template>
        </el-table-column>
        <el-table-column label="金额" width="120">
          <template slot-scope="scope">{{ formatAmount(scope.row.amount) }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
        <el-table-column prop="businessMonth" label="业务月份" width="100" />
        <el-table-column label="按月累加" width="90">
          <template slot-scope="scope">{{ scope.row.autoMonthly === '1' ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">{{ formatDate(scope.row.dateCreated) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="isManualItem(scope.row)"
              type="text"
              @click="$emit('edit-item', scope.row, header)"
            >编辑</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getPersonCostDetail } from '@/api/provision/provisionRule'
import * as ProvisionConstants from '@/class/cargo/model/parameters/ProvisionConstants'

export default {
  name: 'PersonCostDetailDialog',
  props: {
    visible: { type: Boolean, default: false },
    headerUuid: { type: String, default: '' }
  },
  data() {
    return {
      header: null,
      items: [],
      loading: false
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadDetail()
      } else {
        this.resetDetail()
      }
    }
  },
  methods: {
    resetDetail() {
      this.header = null
      this.items = []
      this.loading = false
    },
    costTypeLabel(code) {
      return ProvisionConstants.getPersonCostTypeLabel(code)
    },
    isManualItem(row) {
      return row && row.costType !== 'profit_deduct' && row.source !== 'calc'
    },
    formatAmount(val) {
      return val == null ? '0.00' : Number(val).toFixed(2)
    },
    formatDate(val) {
      if (!val) return ''
      const d = new Date(val)
      if (Number.isNaN(d.getTime())) return val
      const pad = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    async loadDetail() {
      if (!this.headerUuid) {
        this.resetDetail()
        return
      }
      this.loading = true
      try {
        const res = await getPersonCostDetail(this.headerUuid)
        if (!res.ok) {
          this.$message.error('加载详情失败')
          this.resetDetail()
          return
        }
        const data = res.data || {}
        this.header = data.header || null
        this.items = data.items || []
      } catch (e) {
        console.error(e)
        this.$message.error('加载详情失败')
        this.resetDetail()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.header-info {
  margin-bottom: 12px;
  display: flex;
  gap: 24px;
  color: #606266;
}
</style>
